/**
 * Build the public share link URL.
 * Format: {origin}/share/{type}/{objectId}
 */
export function buildShareLinkUrl(type: string, objectId: string): string {
  return `${window.location.origin}/share/${type}/${objectId}`;
}
